import {
  BRAZILIAN_PRICING_CUTOFF_DATE,
  BRAZILIAN_PRICING_SUNSET_CUTOFF_DATE,
  getPriceIdMap,
  GetTierFunction
} from '.'
import { AiUserSubscription, BillingCycle } from '../../types'
import { BaseTier, CurrencySymbols, GetPriceIdType, TrainingSpeed } from './BaseTier'

export type ComposerTierType = ComposerTier

class ComposerTier extends BaseTier {
  readonly subscriptionType = AiUserSubscription.COMPOSER
  readonly subscriptionLevel = 4
  readonly vocalLimitMinutes = 100
  readonly downloadMsPerMonth = Infinity
  readonly textToSpeechCharacterLimit = 2500
  readonly modelSlots = 12

  readonly inferenceSecondsPerMonth = Infinity
  readonly advancedSettingsEnabled = true
  readonly artistVoiceModelsEnabled = true
  readonly textToSpeechCharacterConverts = 100_000

  readonly trainingSpeed = TrainingSpeed.PRIORITY
  readonly maxTrainingDatasetMb = 1500
  readonly maxTrainDatasetFileSizeMb = 200
  readonly maxTrainingDatasetDurationMinutes = 60
  readonly maxYoutubeTrainingVideoLengthMinutes = 20
  readonly maxMlTrainingJobsPerMonth = Infinity
  readonly youtubeConvertsPerDay = Infinity

  readonly currencySymbol: CurrencySymbols = CurrencySymbols.USD
  readonly monthlyPrice: number = 59.99
  readonly annualPrice: number = 576

  getPriceId: GetPriceIdType = (billingCycle: BillingCycle, isProd: boolean) => {
    return getPriceIdMap(isProd, billingCycle).COMPOSER_PRICE
  }
}

/**
 * The tier for users that created accounts after BRAZILIAN_PRICING_CUTOFF_DATE
 */
class ComposerBrazilTier extends ComposerTier {
  readonly currencySymbol = CurrencySymbols.BRL
  readonly monthlyPrice: number = 150
  readonly annualPrice: number = 1440

  getPriceId: GetPriceIdType = (billingCycle: BillingCycle, isProd: boolean) => {
    return getPriceIdMap(isProd, billingCycle).COMPOSER_PRICE_BRAZIL
  }
}

const composerTierInstance = new ComposerTier()
const composerBrazilTierInstance = new ComposerBrazilTier()

export const getUserComposerTier: GetTierFunction<ComposerTierType> = (user) => {
  if (!user) return composerTierInstance
  const createdAtDate = new Date(user.createdAt)

  const brazilSunsetCutoffDate = new Date(BRAZILIAN_PRICING_SUNSET_CUTOFF_DATE)
  const brazilCutoffDate = new Date(BRAZILIAN_PRICING_CUTOFF_DATE)
  if (
    createdAtDate > brazilCutoffDate &&
    createdAtDate < brazilSunsetCutoffDate &&
    user.countryCode === 'BR'
  ) {
    return composerBrazilTierInstance
  }

  return composerTierInstance
}

export { composerTierInstance as ComposerTier, composerBrazilTierInstance as ComposerBrazilTier }
